import { Grid, Stack, Tooltip, Typography } from "@mui/material";
import type { FC } from "react";

export const AnalyticsOverviewItem: FC<{
  title: string;
  icon: React.JSX.Element;
  children: React.ReactNode;
  tooltip?: string;
  mdSize?: number;
}> = ({ title, icon, children, tooltip, mdSize = 3 }) => {
  return (
    <Grid
      size={{ xs: 12, sm: 6, md: mdSize }}
      // Force the stacks to shrink to fit the content so the tooltop arrow is centered.
      display="flex"
    >
      <Tooltip title={tooltip} placement="top" arrow>
        <Stack direction="column" spacing={1}>
          <Stack direction="row" alignItems="center" spacing={1}>
            {icon}
            <Typography variant="overline" color="textSecondary">
              {title}
            </Typography>
          </Stack>
          {children}
        </Stack>
      </Tooltip>
    </Grid>
  );
};
